import { FC } from "react";

import { AfrezzaLogo } from "../../assets"
import { FooterTextProps } from "./types";



const FooterText: FC<FooterTextProps> = (): JSX.Element => {
  return (
      <div className="footer-copyrights">
          <div className="row mt-4 mt-md-5 pb-3">
            <div className="col-xl-3 col-lg-4 col-md-4 col-12">
              <img className={"pb-2 p-lg-0"} alt="afrezza" src={AfrezzaLogo}/>
            </div>
            <div className="col-xl-9 col-lg-8 col-md-8 col-12">
              <small className="d-flex flex-column">
                  AFREZZA, the Afrezza logo, and MANNKIND are registered trademarks of MANNKIND Corporation.
                  <br/>
                  © 2026 MannKind Corporation.
                  <br/>
                  US-AFR-2996 May 2026
                  <br/>
                  This site is intended for use by U.S. residents only.
              </small>
            </div>
          </div>
      </div>
  );
};

export default FooterText;
